import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import useTranslator from "../../../hooks/useTranslator";

const EvapBox = ({ label, value, unit, isLoading = false }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {isLoading
        ? <span className="db-shimmer" style={{ height: 24, width: 60, display: "block" }} />
        : <>{value ?? "—"}{unit && <span className="db-metric-unit"> {unit}</span>}</>
      }
    </div>
  </div>
);

const RunningTotalsExtra = ({ data = {}, isLoading = false }) => {
  const { _t } = useTranslator();
  const prcsMetrics   = data?.processing_metrics ?? {};
  const packingMetrics = data?.packing_analytics ?? {};

  return (
    <div className="rte-wrapper">

      <DashboardCard title={_t("processing_text", "Processing")}>
        <div className="db-evap-row">
          <EvapBox label={_t("total_accepted_kg", "TOTAL ACCEPTED KG")}     value={prcsMetrics?.total_accepted_in_processing ?? 0} unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("total_cases_processed", "TOTAL CASES PROCESSED")} value={prcsMetrics?.total_cases_processed ?? 0}                  isLoading={isLoading} />
          <EvapBox label={_t("gas_liters", "GAS LITERS")}            value={prcsMetrics?.total_gas_consumed_ltr ?? 0}        unit="L"  isLoading={isLoading} />
          <EvapBox label={_t("gas_costing", "GAS COSTING")}           value={prcsMetrics?.total_gas_cost ? `$${prcsMetrics.total_gas_cost}` : "0"} isLoading={isLoading} />
        </div>
      </DashboardCard>

      <DashboardCard title={_t("packing", "Packing")}>
        <div className="db-evap-row">
          <EvapBox label={_t("prime_cheeks_packed", "PRIME CHEEKS PACKED")}      value={packingMetrics?.prime_cheeks_packed_kg ?? 0}      unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("prime_strips_packed", "PRIME STRIPS PACKED")}      value={packingMetrics?.prime_strips_packed_kg ?? 0}      unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("total_boxes_packed_prime", "TOTAL BOXES PACKED PRIME")} value={packingMetrics?.total_prime_packed_boxes ?? 0}              isLoading={isLoading} />
        </div>
        <div className="db-evap-row" style={{ borderTop: "1px solid #f0f1f3", paddingTop: 12 }}>
          <EvapBox label={_t("brokering_kg_prime", "BROKERING KG PRIME")}       value={packingMetrics?.total_prime_kg_from_brokerage ?? 0}  unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("brokering_2nd_and_pieces", "BROKERING 2ND & PIECES")}   value={`${packingMetrics?.total_second_kg_from_brokerage ?? 0} & ${packingMetrics?.total_pieces_kg_from_brokerage ?? 0}`} unit="kg" isLoading={isLoading} />
          <EvapBox label={_t("pasting_boxes_brok_pack", "PASTING BOXES (BROK+PACK)")} value={packingMetrics?.total_pasted_boxes_packed ?? 0}              isLoading={isLoading} />
        </div>
      </DashboardCard>

    </div>
  );
};

export default RunningTotalsExtra;
